"use strict";

import Common from "../Common";
import CommonGame from "../CommonGame";


//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function UICarousel() {
    PIXI.Container.call(this);


    // Constants.
    this.PAGE_WIDTH = 800;
    this.DEFAULT_ITEM_SCALE = 0; // To be later initialized.
    this.UNSELECTED_ITEM_SCALE_DELTA = 0.1; // If an item is not currently selected, scale it down by this amount.
    this.SELECTED_ITEM_EXIT_EASE_FACTOR = 0.2; // Decrease the distance of the swipe gesture for the selected item.


    // Attributes.
    this._pageContainer = null;
    this._interactiveArea = null;
    this._mask = null;
    this._startX = 0;
    this._lastX = 0;
    this._currentX = 0;
    this._itemIndex = 0;


    // Signals.
    this.signals = {};
    this.signals.onIndexChanged = new signals.Signal();
    this.signals.onItemSelected = new signals.Signal();
}
export default UICarousel;
//module.exports                  	= UICarousel;
UICarousel.prototype = Object.create(PIXI.Container.prototype);
UICarousel.prototype.constructor = UICarousel;


//===================================================
//
// Public
//
//===================================================

UICarousel.prototype.init = function (items) {
    this.position = new PIXI.Point(Common.STAGE_WIDTH * 0.5, Common.STAGE_HEIGHT * 0.5);

    // Mask.
    this._mask = new PIXI.Graphics();
    this._mask.beginFill(0xFFFFFF, 0);
    this._mask.drawRect(-Common.STAGE_WIDTH * 0.5, -Common.STAGE_HEIGHT * 0.5, Common.STAGE_WIDTH, Common.STAGE_HEIGHT);
    this._mask.endFill();
    this.addChild(this._mask);

    // Interactive area.
    this._interactiveArea = new PIXI.Sprite(Common.blankTexture);
    this._interactiveArea.tint = 0xFFFFFF;
    this._interactiveArea.alpha = 0;
    this._interactiveArea.height = 400;
    this._interactiveArea.width = Common.STAGE_WIDTH;
    this._interactiveArea.anchor = new PIXI.Point(0.5, 0.5);
    this._interactiveArea.buttonMode = true;
    this._interactiveArea.interactive = true;
    this._interactiveArea.mousedown = this._interactiveArea.touchstart = this._onMouseDown.bind(this);
    this._interactiveArea.mouseup = this._interactiveArea.touchend = this._onMouseUp.bind(this);
    this._interactiveArea.mouseupoutside = this._interactiveArea.touchendoutside = this._onMouseUp.bind(this);

    this.addChild(this._interactiveArea);

    // Item container.
    this._pageContainer = new PIXI.Container();
    this._pageContainer.anchor = new PIXI.Point(0.5, 0.5);
    this._pageContainer.mask = this._mask;
    this._pageContainer.x = -this.PAGE_WIDTH * 0.5;
    this.addChild(this._pageContainer);

    // Items.
    var i = 0;
    for (var item of items) {
        if (this.DEFAULT_ITEM_SCALE == 0)
            this.DEFAULT_ITEM_SCALE = item.scale.x;

        // Page.
        var page = new PIXI.Container();
        page.anchor = new PIXI.Point(0, 0.5);
        this._pageContainer.addChild(page);
        // So we can keep some distance between items.
        var pageBg = new PIXI.Sprite(Common.blankTexture);
        pageBg.alpha = 0;
        pageBg.anchor = new PIXI.Point(0, 0.5);
        pageBg.width = this.PAGE_WIDTH;
        pageBg.height = item.height;
        page.addChild(pageBg);
        // Item.
        item.x = item.width * 0.5 + ( pageBg.width - item.width ) * 0.5;
        page.addChild(item);
        // Initial scale.
        if (i > 0)
            item.scale = new PIXI.Point(
                this.DEFAULT_ITEM_SCALE - this.UNSELECTED_ITEM_SCALE_DELTA,
                this.DEFAULT_ITEM_SCALE - this.UNSELECTED_ITEM_SCALE_DELTA);

        page.x = i * page.width;

        ++i;
    }
};

UICarousel.prototype.update = function () {
    this._updateItemHiglighting();
};

UICarousel.prototype.animateIn = function () {
    this._pageContainer.children[0].y -= 100;
    this._pageContainer.children[0].alpha = 0;
    TweenMax.to(this._pageContainer.children[0], 0.25, {
        alpha: 1,
        y: this._pageContainer.children[0].y + 100,
        ease: Sine.easeOut
    });
};

UICarousel.prototype.next = function () {
    if (this._itemIndex < this._pageContainer.children.length - 1) {
        this._itemIndex += 1;

        TweenMax.to(this._pageContainer, 0.25, {
            x: -this._itemIndex * this.PAGE_WIDTH - this.PAGE_WIDTH * 0.5,
            ease: Sine.easeInOut,
            onComplete: function () {
                this.signals.onIndexChanged.dispatch();
            },
            onCompleteScope: this
        });

        // Sfx.
        Common.audio.playSound("sfx_ui_carousel_swipe_00");
    }
};

UICarousel.prototype.prev = function () {
    if (this._itemIndex > 0) {
        this._itemIndex -= 1;

        TweenMax.to(this._pageContainer, 0.25, {
            x: -this._itemIndex * this.PAGE_WIDTH - this.PAGE_WIDTH * 0.5,
            ease: Sine.easeInOut,
            onComplete: function () {
                this.signals.onIndexChanged.dispatch();
            },
            onCompleteScope: this
        });

        // Sfx.
        Common.audio.playSound("sfx_ui_carousel_swipe_00");
    }
};


//===================================================
//
// Private
//
//===================================================

UICarousel.prototype._updateItemHiglighting = function () {
    // Highlight selection.
    var pageFactor = Math.abs(this._pageContainer.x) / this.PAGE_WIDTH;
    var itemIndexAux = Math.floor(pageFactor);
    // Ease changing the selection of the current item.
    if (this._itemIndex == itemIndexAux) {
        if (Math.abs(this._itemIndex - pageFactor) <= 0.5 - this.SELECTED_ITEM_EXIT_EASE_FACTOR
            && this._itemIndex > 0)
            itemIndexAux -= 1;
        else if (Math.abs(this._itemIndex - pageFactor) >= 0.5 + this.SELECTED_ITEM_EXIT_EASE_FACTOR
            && this._itemIndex < this._pageContainer.children.length - 1)
            itemIndexAux += 1;
    }

    var itemIndex = 0;
    for (var page of this._pageContainer.children) {
        var item = page.children[1];
        if (!TweenMax.isTweening(item.scale)) {
            if (itemIndex == itemIndexAux && item.scale.x != this.DEFAULT_ITEM_SCALE)
                TweenMax.to(item.scale, 0.12, {
                    x: this.DEFAULT_ITEM_SCALE,
                    y: this.DEFAULT_ITEM_SCALE,
                    ease: Sine.easeInOut
                });
            else if (itemIndex != itemIndexAux && item.scale.x != this.DEFAULT_ITEM_SCALE - this.UNSELECTED_ITEM_SCALE_DELTA)
                TweenMax.to(item.scale, 0.12, {
                    x: this.DEFAULT_ITEM_SCALE - this.UNSELECTED_ITEM_SCALE_DELTA,
                    y: this.DEFAULT_ITEM_SCALE - this.UNSELECTED_ITEM_SCALE_DELTA,
                    ease: Sine.easeInOut
                });
        }

        ++itemIndex;
    }
};

UICarousel.prototype._snap = function () {
    var pageFactor = Math.abs(this._pageContainer.x) / this.PAGE_WIDTH;
    var newItemIndex = Math.floor(pageFactor);
    // Ease changing the selection of the current item.
    if (newItemIndex == this._itemIndex) {
        if (Math.abs(newItemIndex - pageFactor) <= 0.5 - this.SELECTED_ITEM_EXIT_EASE_FACTOR
            && newItemIndex > 0)
            newItemIndex -= 1;
        else if (Math.abs(newItemIndex - pageFactor) >= 0.5 + this.SELECTED_ITEM_EXIT_EASE_FACTOR
            && newItemIndex < this._pageContainer.children.length - 1)
            newItemIndex += 1;
    }

    TweenMax.to(this._pageContainer, 0.25, {
        x: -newItemIndex * this.PAGE_WIDTH - this.PAGE_WIDTH * 0.5,
        ease: Sine.easeInOut,
        onComplete: function (newItemIndex) {
            this._itemIndex = newItemIndex;
            this.signals.onIndexChanged.dispatch();
        },
        onCompleteScope: this,
        onCompleteParams: [newItemIndex]
    });
};


//===================================================
//
// Events
//
//===================================================

UICarousel.prototype._onMouseDown = function (mouseData) {
    TweenMax.killTweensOf(this._pageContainer);

    var localPos = mouseData.data.getLocalPosition(this._interactiveArea);
    this._startX = localPos.x;
    this._lastX = this._startX;
    this._currentX = this._startX;

    this._interactiveArea.mousemove = this._interactiveArea.touchmove = this._onMouseMove.bind(this);
};

UICarousel.prototype._onMouseMove = function (mouseData) {
    var localPos = mouseData.data.getLocalPosition(this._interactiveArea);

    this._currentX = localPos.x;

    this._pageContainer.x += ( this._currentX - this._lastX ) * Common.STAGE_WIDTH;
    if (this._pageContainer.x > -this.PAGE_WIDTH * 0.5)
        this._pageContainer.x = -this.PAGE_WIDTH * 0.5;
    else if (this._pageContainer.x < -( this._pageContainer.children.length - 0.5 ) * this.PAGE_WIDTH)
        this._pageContainer.x = -( this._pageContainer.children.length - 0.5 ) * this.PAGE_WIDTH;

    this._lastX = this._currentX;
};

UICarousel.prototype._onMouseUp = function (mouseData) {
    var result = false;
    if (Math.abs(this._startX - this._currentX) <= 0.01) {
        var selectedItem = this._pageContainer.children[this._itemIndex].children[1];
        var localPos = mouseData.data.getLocalPosition(selectedItem);
        if (Math.abs(localPos.x) <= selectedItem.width * 0.8
            && Math.abs(localPos.y) <= selectedItem.height * 0.8) {
            this.signals.onItemSelected.dispatch();

            result = true;
        }
    }

    if (!result) {
        this._interactiveArea.mousemove = this._interactiveArea.touchmove = null;

        this._snap();


        // Sfx.
        Common.audio.playSound("sfx_ui_carousel_swipe_00");
    }
};


//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(
    UICarousel.prototype,
    "selectedIndex",
    {
        get: function () {
            return this._itemIndex;
        }
    });